/* =====================================================================
   Wise — Fiche produit (wh-pdp) · assets/wh-pdp.js
   Chargé en defer après wh-core.js ; wise.js (fin de body) a déjà relié
   ses comportements quand ce fichier s'initialise. ES2017 au plus, IIFE,
   sans dépendance (window.WH utilisé s'il existe), idempotent, initialisé
   au chargement et à chaque shopify:section:load.

   Partage des rôles, sans double liaison :
   - wise.js (inchangé) : variantes (.opt/.v-btn, prix, [data-variant-id]),
     ajout au panier AJAX + tiroir, favoris, affichage de #sticky-atc et clic
     sur [data-sticky-atc], guide des tailles (ouverture, calculs), dates de
     livraison [data-delivery-range], récemment consultés.
   - ce fichier observe le résultat (écouteur délégué en bulle sur la racine
     de section, MutationObserver) et ajoute : galerie tactile, miniatures,
     loupe, visionneuse plein écran ; libellés « Choisir une taille / Épuisé »
     et garde de taille manquante (écouteur submit en capture) ; image et URL
     de la variante ; alerte de retour en stock ; barre « livraison offerte »
     (vrai panier /cart.js) ; lien WhatsApp ; accordéons ; « Lire la suite » ;
     colonne d'achat collante ; accessibilité (aria-pressed, focus).
   ===================================================================== */
(function () {
  'use strict';

  var W = window;
  var D = document;
  if (W.__whPdpLoaded) return;
  W.__whPdpLoaded = true;

  var ROOT = '[data-wh-pdp]';
  var TXT_ADD = 'Add to bag';
  var TXT_OUT = 'Sold out';
  var TXT_NONE = 'Unavailable';

  /* ---------- Utilitaires ---------- */
  function media(query) {
    return W.matchMedia ? W.matchMedia(query) : null;
  }

  var mqReduce = media('(prefers-reduced-motion: reduce)');
  var mqFine = media('(hover: hover) and (pointer: fine)');
  var mqMobile = media('(max-width: 749.98px)');
  var mqColumns = media('(min-width: 750px)');

  function reduced() { return !!(mqReduce && mqReduce.matches); }
  function finePointer() { return !!(mqFine && mqFine.matches); }
  function isMobile() { return !!(mqMobile && mqMobile.matches); }
  function designMode() { return !!(W.Shopify && W.Shopify.designMode); }

  function all(sel, ctx) {
    var base = ctx || D;
    return base && base.querySelectorAll ? Array.prototype.slice.call(base.querySelectorAll(sel)) : [];
  }

  function one(sel, ctx) {
    var base = ctx || D;
    return base && base.querySelector ? base.querySelector(sel) : null;
  }

  function listen(target, type, fn, opts, bag) {
    var o = opts || false;
    target.addEventListener(type, fn, o);
    if (bag) bag.push(function () { target.removeEventListener(type, fn, o); });
  }

  function readJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (err) { return null; }
  }

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }

  function frame(fn) {
    return W.requestAnimationFrame ? W.requestAnimationFrame(fn) : W.setTimeout(fn, 16);
  }

  function debounce(fn, wait) {
    var t = 0;
    return function () {
      var args = arguments;
      var ctx = this;
      W.clearTimeout(t);
      t = W.setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function report(err) {
    if (W.console && typeof W.console.error === 'function') W.console.error('[wh-pdp]', err);
  }

  function safe(fn) {
    try { return fn(); } catch (err) { report(err); return undefined; }
  }

  function focusEl(el) {
    if (!el || typeof el.focus !== 'function') return;
    try { el.focus({ preventScroll: true }); } catch (err) { el.focus(); }
  }

  function connected(el) {
    return !!el && D.documentElement.contains(el);
  }

  function scrollToX(el, left, instant) {
    if (instant || reduced() || typeof el.scrollTo !== 'function') {
      el.scrollLeft = left;
      return;
    }
    try { el.scrollTo({ left: left, behavior: 'smooth' }); } catch (err) { el.scrollLeft = left; }
  }

  var decoder = null;
  function decode(text) {
    if (text.indexOf('&') === -1) return text;
    decoder = decoder || D.createElement('textarea');
    decoder.innerHTML = text;
    return decoder.value;
  }

  /* Même rendu que formatMoney() de wise.js (format de la boutique). */
  function money(cents) {
    var cfg = W.WiseSettings || {};
    var n = Number(cents) || 0;
    var parts = (n / 100).toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    var fmt = String(cfg.moneyFormat || '{{amount_with_comma_separator}} €');
    var amount;
    if (fmt.indexOf('amount_no_decimals') !== -1) {
      amount = Math.round(n / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    } else if (fmt.indexOf('amount_with_comma_separator') !== -1) {
      amount = whole + ',' + parts[1];
    } else {
      amount = whole + '.' + parts[1];
    }
    return decode(fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/g, amount).replace(/<[^>]+>/g, '')).trim();
  }

  function slug(value) {
    var s = String(value || '').toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return s.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  /* Texte visible d'un fragment HTML (entités décodées, espaces insécables compris). */
  function plainText(html) {
    return decode(String(html).replace(/<[^>]+>/g, '')).replace(/\s+/g, ' ').trim();
  }

  /* Bas du header fixe du thème (0 s'il n'est pas fixe). */
  function headerBottom() {
    var head = D.querySelector('[data-v23-header]');
    if (!head) return 0;
    var pos = W.getComputedStyle(head).position;
    if (pos !== 'fixed' && pos !== 'sticky') return 0;
    return Math.max(0, head.getBoundingClientRect().bottom);
  }

  function inViewport(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    var vh = W.innerHeight || D.documentElement.clientHeight;
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < vh;
  }

  /* ---------- Variantes : état calculé depuis le DOM tenu par wise.js ---------- */
  function sameOptions(v, sel, strict) {
    for (var j = 0; j < sel.length; j++) {
      if (sel[j] === null) {
        if (strict) return false;
        continue;
      }
      if (!v.options || v.options[j] !== sel[j]) return false;
    }
    return true;
  }

  function currentVariant(api) {
    var id = Number(api.cfg.currentId);
    for (var i = 0; i < api.variants.length; i++) {
      if (api.variants[i].id === id) return api.variants[i];
    }
    return api.variants[0] || null;
  }

  function computeState(api) {
    var sel = api.opts.map(function (opt) {
      var b = one('.v-btn.is-active', opt);
      return b ? b.getAttribute('data-value') : null;
    });
    var missing = null;
    for (var i = 0; i < sel.length; i++) {
      if (sel[i] === null) {
        missing = api.opts[i];
        break;
      }
    }
    var variant = null;
    if (!api.opts.length) {
      variant = api.variants[0] || null;
    } else if (!missing) {
      for (var k = 0; k < api.variants.length; k++) {
        if (sameOptions(api.variants[k], sel, true)) {
          variant = api.variants[k];
          break;
        }
      }
    }
    var ref = variant;
    if (!ref) {
      for (var m = 0; m < api.variants.length; m++) {
        var v = api.variants[m];
        if (!sameOptions(v, sel, false)) continue;
        if (!ref) ref = v;
        if (v.available) {
          ref = v;
          break;
        }
      }
    }
    api.state = {
      sel: sel,
      missing: missing,
      variant: variant,
      ref: ref || currentVariant(api)
    };
    return api.state;
  }

  function mediaFor(api, st) {
    if (st.variant && st.variant.media) return st.variant.media;
    for (var i = 0; i < api.variants.length; i++) {
      var v = api.variants[i];
      if (v.media && sameOptions(v, st.sel, false)) return v.media;
    }
    return 0;
  }

  function variantLabel(api, v) {
    if (!v || api.cfg.single) return '';
    var names = api.cfg.optionNames || [];
    if (names.length === 1 && api.variants.length > 1) return names[0] + ' ' + v.title;
    return v.title || '';
  }

  function hasSizeChoice(api) {
    return api.opts.some(function (opt) {
      return opt.getAttribute('data-wh-pdp-opt') === 'size' && !opt.classList.contains('wh-pdp__opt--solo');
    });
  }

  function desired(api, st) {
    if (api.cfg.available === false) return { label: TXT_OUT, price: false, disabled: true };
    if (st.missing) {
      return {
        label: st.missing.getAttribute('data-wh-pdp-choose') || 'Choose a size',
        price: false,
        disabled: false,
        needs: true
      };
    }
    var v = st.variant;
    if (!v) return { label: TXT_NONE, price: false, disabled: true, none: true };
    if (!v.available) return { label: TXT_OUT, price: false, disabled: true };
    return { label: TXT_ADD, price: true, cents: v.price, disabled: false };
  }

  /* ---------- Synchronisation de l'interface ---------- */
  function syncOptions(api) {
    api.opts.forEach(function (opt) {
      var chosen = false;
      all('.v-btn', opt).forEach(function (b) {
        var on = b.classList.contains('is-active');
        if (on) chosen = true;
        var pressed = on ? 'true' : 'false';
        if (b.getAttribute('aria-pressed') !== pressed) b.setAttribute('aria-pressed', pressed);
        var out = one('[data-wh-pdp-out]', b);
        if (out) {
          var isOut = b.classList.contains('is-out');
          if (out.hidden === isOut) out.hidden = !isOut;
        }
      });
      if (chosen) {
        var err = one('[data-wh-pdp-need]', opt);
        if (err && err.textContent) err.textContent = '';
        opt.classList.remove('is-invalid');
      }
    });
  }

  function syncPrice(api, st) {
    var v = st.variant || st.ref;
    if (!v) return;
    var sale = Number(v.compare_at_price) > Number(v.price);
    var price = one('[data-price]', api.root);
    if (price) price.classList.toggle('is-sale', sale);
    var was = one('[data-wh-pdp-was]', api.root);
    if (was && was.hidden === sale) was.hidden = !sale;
    var pct = one('[data-wh-pdp-pct]', api.root);
    if (pct) {
      pct.hidden = !sale;
      if (sale) {
        var txt = '\u2212' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '\u00a0%';
        if (pct.textContent !== txt) pct.textContent = txt;
      }
    }
  }

  function syncAtc(api, st) {
    var btn = api.atc;
    if (!btn || !api.variants.length) return;
    var d = desired(api, st);
    api.desired = d;
    var added = btn.classList.contains('is-added');
    var busy = btn.disabled && !d.disabled && !added;
    if (btn.classList.contains('is-busy') !== busy) btn.classList.toggle('is-busy', busy);
    if (d.none && !btn.disabled) btn.disabled = true;
    if (added) return; /* « Ajouté au panier » : retour visuel de wise.js */
    /* On compare l'ÉTAT rendu (clé + nœud posé par nous), jamais le texte affiché :
       wise-chrome-i18n.js traduit ce texte (/en/), et le comparer au français
       relancerait une réécriture à chaque traduction (boucle d'observateurs). */
    var key = d.label + '|' + (d.price ? d.cents : '');
    var label = one('.wh-pdp__atc-label', btn);
    var total = one('[data-atc-total]', btn);
    if (api.atcLabel === undefined && label && label.textContent === d.label && !!total === !!d.price) {
      api.atcLabel = label; /* rendu serveur déjà juste : on l'adopte sans réécrire */
      api.atcKey = key;
    }
    if (label !== api.atcLabel || api.atcKey !== key || !!total !== !!d.price) {
      btn.innerHTML = '<span class="wh-pdp__atc-label">' + esc(d.label) + '</span>' +
        (d.price ? '<span class="wh-pdp__atc-sep" aria-hidden="true">&middot;</span><span class="wh-pdp__atc-price" data-atc-total>' + esc(money(d.cents)) + '</span>' : '');
      api.atcLabel = one('.wh-pdp__atc-label', btn);
      api.atcKey = key;
    }
  }

  function syncSticky(api, st) {
    if (!api.variants.length) return;
    var d = desired(api, st);
    var b = api.stickyBtn;
    if (b) {
      /* Même principe : wise.js remplace le nœud texte (textContent) à chaque
         changement de variante ; la traduction, elle, garde le nœud (nodeValue). */
      var node = b.firstChild;
      if (api.stickyNode === undefined && b.childNodes.length === 1 && node && node.nodeType === 3 && b.textContent === d.label) {
        api.stickyNode = node;
        api.stickyKey = d.label;
      }
      if (api.stickyKey !== d.label || node !== api.stickyNode || b.childNodes.length !== 1) {
        b.textContent = d.label;
        api.stickyNode = b.firstChild;
        api.stickyKey = d.label;
      }
      if (d.none && !b.disabled) b.disabled = true;
    }
    var meta = one('[data-wh-pdp-sticky-variant]', api.root);
    if (meta) {
      var txt = st.variant ? variantLabel(api, st.variant) : '';
      if (meta.textContent !== txt) meta.textContent = txt;
      meta.hidden = !txt;
    }
  }

  function syncRestock(api, st) {
    var box = api.restock;
    if (!box || !api.variants.length) return;
    var v = st.variant;
    var show = api.cfg.available === false || !!(v && !v.available) || !!box.__whForce;
    if (box.hidden === show) box.hidden = !show;
    var text = one('[data-wh-pdp-restock-text]', box);
    if (text) {
      var t = (api.cfg.available !== false && hasSizeChoice(api))
        ? 'This size is sold out. Leave your email and we will let you know when it is back.'
        : 'This item is sold out. Leave your email and we will let you know when it is back.';
      /* Clé d'état plutôt que texte affiché (qui peut être traduit en /en/) */
      if (api.restockKey === undefined && text.textContent === t) api.restockKey = t;
      if (api.restockKey !== t) {
        text.textContent = t;
        api.restockKey = t;
      }
    }
    var tags = one('[data-wh-pdp-restock-tags]', box);
    if (tags) {
      var base = tags.getAttribute('data-base') || tags.value;
      tags.value = (v && !api.cfg.single) ? base + ',variante-' + slug(v.title) : base;
    }
    var ret = one('[data-wh-pdp-restock-return]', box);
    if (ret && v) {
      var path = ret.getAttribute('data-base') || api.cfg.path || W.location.pathname;
      ret.value = path + '?variant=' + v.id + '#wh-pdp-restock';
    }
  }

  function syncShip(api) {
    var s = api.ship;
    if (!s || !s.box) return;
    var threshold = Number(api.cfg.threshold) || 0;
    if (!threshold) {
      s.box.hidden = true;
      return;
    }
    var st = api.state || computeState(api);
    var cart = api.cart || { total: 0, ids: [] };
    var v = st.variant || st.ref;
    var available = api.cfg.available !== false && !!v && v.available !== false;
    var inCart = !!v && cart.ids.indexOf(Number(v.id)) !== -1;
    var add = (available && !inCart) ? (Number(v.price) || 0) : 0;
    var projected = cart.total + add;
    var html;
    var free = true;
    if (cart.total >= threshold) {
      html = 'Your order qualifies for free UK delivery.';
    } else if (projected >= threshold) {
      html = 'Add this item for free UK delivery.';
    } else {
      free = false;
      var rest = '<strong>' + esc(money(threshold - projected)) + '</strong>';
      html = add
        ? 'Add this item and you’re ' + rest + ' away from free UK delivery.'
        : 'You’re ' + rest + ' away from free UK delivery.';
    }
    /* On ne réécrit la zone (aria-live) que si l'état change vraiment : clé mémorisée,
       pas le texte affiché (traduit en /en/ par wise-chrome-i18n.js). */
    if (s.msg) {
      if (s.key === undefined && s.msg.textContent.replace(/\s+/g, ' ').trim() === plainText(html)) s.key = html;
      if (s.key !== html) {
        s.msg.innerHTML = html;
        s.key = html;
      }
    }
    if (s.bar) s.bar.style.setProperty('--wh-pdp-ship', clamp(Math.round(projected * 100 / threshold), 0, 100) + '%');
    s.box.classList.toggle('is-free', free);
  }

  function syncWhatsApp(api, st) {
    var a = api.wa;
    if (!a || !api.cfg.wa) return;
    var label = st.variant ? variantLabel(api, st.variant) : '';
    var text = String(api.cfg.waIntro || '') + ' ' + String(api.cfg.title || '') +
      (label ? ' (' + label + ')' : '') + ' ' + String(api.cfg.url || W.location.href);
    var href = api.cfg.wa + '?text=' + encodeURIComponent(text.trim());
    if (a.getAttribute('href') !== href) a.setAttribute('href', href);
  }

  function updateUrl(v) {
    if (designMode() || !v || !W.history || typeof W.history.replaceState !== 'function' || typeof W.URL !== 'function') return;
    try {
      var url = new W.URL(W.location.href);
      if (url.searchParams.get('variant') === String(v.id)) return;
      url.searchParams.set('variant', v.id);
      W.history.replaceState(W.history.state, '', url.toString());
    } catch (err) { /* navigateur sans URL API : on garde l'adresse */ }
  }

  function sync(api, opts) {
    var o = opts || {};
    var st = computeState(api);
    syncOptions(api);
    syncPrice(api, st);
    syncAtc(api, st);
    syncSticky(api, st);
    syncRestock(api, st);
    syncShip(api);
    syncWhatsApp(api, st);
    if (o.user) {
      if (st.variant) updateUrl(st.variant);
      var mediaId = mediaFor(api, st);
      if (mediaId && api.gallery) api.gallery.showMedia(mediaId);
    }
  }

  /* Taille manquante au clic sur « Ajouter » : message, rappel visuel, focus. */
  function promptChoice(api, opt) {
    var err = one('[data-wh-pdp-need]', opt);
    if (err) {
      var msg = err.getAttribute('data-msg') || 'Choose your size to continue.';
      err.textContent = '';
      W.setTimeout(function () { err.textContent = msg; }, 40);
    }
    opt.classList.remove('is-invalid');
    void opt.offsetWidth;
    opt.classList.add('is-invalid');
    W.clearTimeout(api.invalidTimer);
    api.invalidTimer = W.setTimeout(function () { opt.classList.remove('is-invalid'); }, 1400);
    var r = opt.getBoundingClientRect();
    var vh = W.innerHeight || D.documentElement.clientHeight;
    if (r.top < headerBottom() + 12 || r.bottom > vh - 150) {
      try {
        opt.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' });
      } catch (x) {
        opt.scrollIntoView();
      }
    }
    focusEl(one('.v-btn:not(.is-out)', opt) || one('.v-btn', opt));
  }

  /* Garde en capture : passe AVANT l'écouteur submit de wise.js et l'arrête
     seulement s'il manque une taille (aucune double liaison de l'ajout). */
  function onSubmitCapture(e) {
    var form = e.target;
    if (!form || form.nodeType !== 1 || typeof form.closest !== 'function') return;
    var root = form.closest(ROOT);
    var api = root && root.__whPdp;
    if (!api || form !== api.form || !api.variants.length) return;
    var st = computeState(api);
    if (!st.missing && st.variant && st.variant.available !== false) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    if (st.missing) promptChoice(api, st.missing);
  }

  function fly(api) {
    if (typeof W.wiseFlyToCart !== 'function') return;
    var img = api.gallery ? api.gallery.currentImage() : null;
    if (!inViewport(img)) {
      var thumb = one('.wh-pdp__sticky.is-on .wh-pdp__sticky-img', api.root);
      img = inViewport(thumb) ? thumb : null;
    }
    if (img) safe(function () { W.wiseFlyToCart(img); });
  }

  function initVariants(api) {
    var root = api.root;
    /* Écouteur délégué en bulle : wise.js a déjà traité le clic sur le bouton. */
    listen(root, 'click', function (e) {
      var t = e.target;
      if (!t || typeof t.closest !== 'function') return;
      var vb = t.closest('.v-btn');
      if (vb && root.contains(vb)) {
        sync(api, { user: true });
        return;
      }
      var opener = t.closest('[data-guide-open]');
      if (opener && root.contains(opener)) api.guideOpener = opener;
    }, false, api.bag);

    if (api.atc && W.MutationObserver) {
      var mo = new W.MutationObserver(function () {
        var st = computeState(api);
        syncAtc(api, st);
        var added = api.atc.classList.contains('is-added');
        if (added && !api.flew) {
          api.flew = true;
          fly(api);
        } else if (!added) {
          api.flew = false;
        }
      });
      mo.observe(api.atc, { attributes: true, attributeFilter: ['class', 'disabled'], childList: true, characterData: true, subtree: true });
      api.observers.push(mo);
    }
  }

  /* ---------- Galerie : carrousel tactile, miniatures, flèches, loupe ---------- */
  function initGallery(api) {
    var g = one('[data-wh-pdp-gallery]', api.root);
    var track = g ? one('[data-wh-pdp-track]', g) : null;
    if (!track) return;
    var stage = one('[data-wh-pdp-stage]', g);
    var slides = all('[data-wh-pdp-slide]', track);
    var dots = all('[data-wh-pdp-dot]', g);
    var count = one('[data-wh-pdp-count]', g);
    var thumbs = all('[data-wh-pdp-thumb]', g);
    var thumbsBox = one('[data-wh-pdp-thumbs]', g);
    var prev = one('[data-wh-pdp-prev]', g);
    var next = one('[data-wh-pdp-next]', g);
    var live = one('[data-wh-pdp-live]', g);
    var lens = one('[data-wh-pdp-lens]', g);
    var n = slides.length;
    var index = -1;
    var raf = 0;
    var target = -1;
    var targetTimer = 0;
    var speak = false;
    var lastWidth = track.clientWidth;
    if (!n) return;

    function width() { return track.clientWidth || 1; }
    function current() { return clamp(Math.round(track.scrollLeft / width()), 0, n - 1); }

    function keepThumb(i) {
      var t = thumbs[i];
      if (!t || !thumbsBox || thumbsBox.scrollHeight <= thumbsBox.clientHeight + 1) return;
      var top = t.offsetTop;
      var bottom = top + t.offsetHeight;
      if (top < thumbsBox.scrollTop) thumbsBox.scrollTop = Math.max(0, top - 8);
      else if (bottom > thumbsBox.scrollTop + thumbsBox.clientHeight) thumbsBox.scrollTop = bottom - thumbsBox.clientHeight + 8;
    }

    function paint(i) {
      if (i === index) return;
      index = i;
      slides.forEach(function (s, k) { s.classList.toggle('is-current', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      if (count) count.textContent = (i + 1) + ' / ' + n;
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
      if (prev) prev.setAttribute('aria-disabled', i <= 0 ? 'true' : 'false');
      if (next) next.setAttribute('aria-disabled', i >= n - 1 ? 'true' : 'false');
      if (live && speak) live.textContent = 'Photo ' + (i + 1) + ' of ' + n;
      keepThumb(i);
      if (stage && stage.classList.contains('is-zoom')) stage.classList.remove('is-zoom');
    }

    function onScroll() {
      if (raf) return;
      raf = frame(function () {
        raf = 0;
        var i = current();
        if (target > -1) {
          if (i !== target) return;
          target = -1;
        }
        paint(i);
      });
    }

    function goTo(i, instant) {
      i = clamp(i, 0, n - 1);
      speak = true;
      target = i;
      W.clearTimeout(targetTimer);
      targetTimer = W.setTimeout(function () {
        target = -1;
        onScroll();
      }, instant ? 0 : 900);
      scrollToX(track, i * width(), instant);
      paint(i);
    }

    listen(track, 'scroll', onScroll, { passive: true }, api.bag);
    if (prev) listen(prev, 'click', function () { goTo(index - 1); }, false, api.bag);
    if (next) listen(next, 'click', function () { goTo(index + 1); }, false, api.bag);
    thumbs.forEach(function (t) {
      listen(t, 'click', function () {
        goTo(Number(t.getAttribute('data-wh-pdp-thumb')) || 0);
      }, false, api.bag);
    });

    /* Clavier : flèches quand le rail ou une photo a le focus */
    listen(track, 'keydown', function (e) {
      var onTrack = e.target === track;
      var onSlide = !onTrack && e.target.closest && e.target.closest('[data-wh-pdp-open]');
      if (!onTrack && !onSlide) return;
      var to = -1;
      if (e.key === 'ArrowRight' || e.key === 'Right') to = index + 1;
      else if (e.key === 'ArrowLeft' || e.key === 'Left') to = index - 1;
      else if (e.key === 'Home') to = 0;
      else if (e.key === 'End') to = n - 1;
      if (to < 0) return;
      e.preventDefault();
      goTo(to);
      if (onSlide) focusEl(one('[data-wh-pdp-open]', slides[index]));
    }, false, api.bag);

    /* Ouverture de la visionneuse */
    listen(track, 'click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-wh-pdp-open]') : null;
      if (!b || !api.viewer) return;
      if (stage) stage.classList.remove('is-zoom');
      api.viewer.open(Number(b.getAttribute('data-wh-pdp-open')) || 0, b);
    }, false, api.bag);

    /* Largeur changée (rotation, fenêtre) : on garde la même photo */
    function realign() {
      var w = track.clientWidth;
      if (w === lastWidth) return;
      lastWidth = w;
      if (index > -1) track.scrollLeft = index * width();
    }
    if (W.ResizeObserver) {
      var ro = new W.ResizeObserver(realign);
      ro.observe(track);
      api.observers.push(ro);
    } else {
      listen(W, 'resize', debounce(realign, 120), false, api.bag);
    }

    /* Loupe au survol : souris uniquement. La photo haute définition est chargée
       avant d'afficher la loupe (jamais de fond vide au premier survol). */
    if (api.cfg.zoom && lens && stage) {
      var hovering = false;
      var showLens = function () {
        var s = slides[index];
        var src = s ? s.getAttribute('data-zoom-src') : null;
        if (!src || !hovering) {
          stage.classList.remove('is-zoom');
          return;
        }
        if (lens.__whReady === src) {
          if (lens.__whShown !== src) {
            lens.style.backgroundImage = 'url("' + src.replace(/"/g, '%22') + '")';
            lens.__whShown = src;
          }
          stage.classList.add('is-zoom');
          return;
        }
        if (lens.__whLoading === src) return;
        lens.__whLoading = src;
        var probe = new W.Image();
        probe.onload = function () {
          lens.__whReady = src;
          lens.__whLoading = null;
          showLens();
        };
        probe.onerror = function () { lens.__whLoading = null; };
        probe.src = src;
      };
      listen(stage, 'pointermove', function (e) {
        if (e.pointerType !== 'mouse' || !finePointer()) return;
        if (e.target && e.target.closest && e.target.closest('.wh-pdp__arrow')) {
          hovering = false;
          stage.classList.remove('is-zoom');
          return;
        }
        hovering = true;
        var r = stage.getBoundingClientRect();
        var x = clamp((e.clientX - r.left) / r.width, 0, 1) * 100;
        var y = clamp((e.clientY - r.top) / r.height, 0, 1) * 100;
        lens.style.backgroundPosition = x.toFixed(2) + '% ' + y.toFixed(2) + '%';
        if (!stage.classList.contains('is-zoom')) showLens();
      }, false, api.bag);
      listen(stage, 'pointerleave', function () {
        hovering = false;
        stage.classList.remove('is-zoom');
      }, false, api.bag);
    }

    api.gallery = {
      goTo: goTo,
      index: function () { return index; },
      showMedia: function (id) {
        for (var k = 0; k < n; k++) {
          if (String(slides[k].getAttribute('data-media-id')) === String(id)) {
            if (k !== index) goTo(k);
            return true;
          }
        }
        return false;
      },
      goToImage: function (imageIndex, instant) {
        for (var k = 0; k < n; k++) {
          var b = one('[data-wh-pdp-open]', slides[k]);
          if (b && Number(b.getAttribute('data-wh-pdp-open')) === imageIndex) {
            goTo(k, instant);
            return;
          }
        }
      },
      currentImage: function () {
        var s = slides[index];
        return s ? one('img', s) : null;
      }
    };

    var start = clamp(Number(g.getAttribute('data-start')) || 0, 0, n - 1);
    paint(start);
    if (start > 0) {
      track.scrollLeft = start * width();
      frame(function () { track.scrollLeft = start * width(); });
    }
  }

  /* ---------- Visionneuse plein écran : balayage, zoom, clavier, fermeture ---------- */
  function initViewer(api) {
    var v = one('[data-wh-pdp-viewer]', api.root);
    var track = v ? one('[data-wh-pdp-vtrack]', v) : null;
    var slides = track ? all('[data-wh-pdp-vslide]', track) : [];
    if (!track || !slides.length) return;
    var countEl = one('[data-wh-pdp-vcount]', v);
    var bClose = one('[data-wh-pdp-vclose]', v);
    var bZoom = one('[data-wh-pdp-vzoom]', v);
    var bPrev = one('[data-wh-pdp-vprev]', v);
    var bNext = one('[data-wh-pdp-vnext]', v);
    var n = slides.length;
    var isOpen = false;
    var index = 0;
    var opener = null;
    var raf = 0;
    var hideTimer = 0;
    var hintTimer = 0;
    var gesture = null;
    var lastType = '';
    var lastTap = 0;
    var lastTapX = 0;
    var lastTapY = 0;
    var suppressClick = false;

    function width() { return track.clientWidth || 1; }

    function load(i) {
      var s = slides[i];
      var img = s ? one('img', s) : null;
      if (img && !img.getAttribute('src')) {
        var src = img.getAttribute('data-src');
        if (src) img.setAttribute('src', src);
      }
    }

    function paint(i) {
      index = clamp(i, 0, n - 1);
      if (countEl) countEl.textContent = (index + 1) + ' / ' + n;
      if (bPrev) bPrev.setAttribute('aria-disabled', index <= 0 ? 'true' : 'false');
      if (bNext) bNext.setAttribute('aria-disabled', index >= n - 1 ? 'true' : 'false');
      load(index);
      load(index + 1);
      load(index - 1);
    }

    function zoomed() {
      var s = slides[index];
      return !!(s && s.classList.contains('is-zoomed'));
    }

    function setZoomUi(on) {
      v.classList.toggle('is-zoomed', on);
      if (bZoom) {
        bZoom.setAttribute('aria-pressed', on ? 'true' : 'false');
        bZoom.setAttribute('aria-label', on ? 'Zoom out' : 'Zoom in');
      }
    }

    function unzoom(s) {
      if (!s || !s.classList.contains('is-zoomed')) return;
      s.classList.remove('is-zoomed');
      s.style.removeProperty('--wh-pdp-zw');
      var pan = one('[data-wh-pdp-pan]', s);
      if (pan) {
        pan.scrollLeft = 0;
        pan.scrollTop = 0;
      }
    }

    function unzoomAll() {
      slides.forEach(unzoom);
      setZoomUi(false);
    }

    function zoomAt(cx, cy) {
      var s = slides[index];
      var img = s ? one('img', s) : null;
      var pan = s ? one('[data-wh-pdp-pan]', s) : null;
      if (!img || !pan) return;
      var r = img.getBoundingClientRect();
      if (!r.width || !r.height) return;
      if (typeof cx !== 'number') {
        cx = r.left + r.width / 2;
        cy = r.top + r.height / 2;
      }
      var fx = clamp((cx - r.left) / r.width, 0, 1);
      var fy = clamp((cy - r.top) / r.height, 0, 1);
      var natural = img.naturalWidth || r.width * 2;
      var zw = Math.round(Math.min(r.width * 2.2, Math.max(natural * 1.25, r.width * 1.5)));
      s.style.setProperty('--wh-pdp-zw', zw + 'px');
      s.classList.add('is-zoomed');
      setZoomUi(true);
      v.classList.add('is-hinted');
      var zh = zw * (r.height / r.width);
      pan.scrollLeft = Math.max(0, fx * zw - pan.clientWidth / 2);
      pan.scrollTop = Math.max(0, fy * zh - pan.clientHeight / 2);
    }

    function toggleZoom(cx, cy) {
      if (zoomed()) unzoomAll();
      else zoomAt(cx, cy);
    }

    function goTo(i, instant) {
      i = clamp(i, 0, n - 1);
      unzoomAll();
      scrollToX(track, i * width(), instant);
      paint(i);
    }

    function onScroll() {
      if (raf || !isOpen) return;
      raf = frame(function () {
        raf = 0;
        var i = clamp(Math.round(track.scrollLeft / width()), 0, n - 1);
        if (i !== index) {
          unzoomAll();
          paint(i);
        }
      });
    }

    function resetDrag() {
      track.style.transform = '';
      v.style.opacity = '';
    }

    function endGesture() {
      if (gesture && gesture.axis === 'y') resetDrag();
      gesture = null;
      v.classList.remove('is-panning');
      v.classList.remove('is-dragging');
    }

    function trap(e) {
      var list = [bZoom, bClose, bPrev, bNext].filter(function (b) {
        return b && b.offsetParent !== null && b.getAttribute('aria-disabled') !== 'true';
      });
      e.preventDefault();
      if (!list.length) return;
      var i = list.indexOf(D.activeElement);
      var to;
      if (e.shiftKey) to = i <= 0 ? list.length - 1 : i - 1;
      else to = (i === -1 || i >= list.length - 1) ? 0 : i + 1;
      focusEl(list[to]);
    }

    function onKey(e) {
      if (!isOpen) return;
      var k = e.key;
      if (k === 'Escape' || k === 'Esc') {
        e.preventDefault();
        close();
        return;
      }
      if (k === 'Tab') {
        trap(e);
        return;
      }
      var dir = 0;
      if (k === 'ArrowRight' || k === 'Right') dir = 1;
      else if (k === 'ArrowLeft' || k === 'Left') dir = -1;
      if (zoomed()) {
        var pan = one('[data-wh-pdp-pan]', slides[index]);
        if (!pan) return;
        if (dir) {
          e.preventDefault();
          pan.scrollLeft += dir * 80;
        } else if (k === 'ArrowDown' || k === 'Down' || k === 'ArrowUp' || k === 'Up') {
          e.preventDefault();
          pan.scrollTop += (k === 'ArrowDown' || k === 'Down') ? 80 : -80;
        }
        return;
      }
      if (dir) {
        e.preventDefault();
        goTo(index + dir);
      }
    }

    function open(i, from) {
      if (isOpen) return;
      isOpen = true;
      opener = from || D.activeElement;
      W.clearTimeout(hideTimer);
      resetDrag();
      v.hidden = false;
      v.classList.remove('is-hinted');
      D.documentElement.classList.add('wh-pdp-lock');
      paint(i);
      track.scrollLeft = index * width();
      frame(function () {
        track.scrollLeft = index * width();
        v.classList.add('is-open');
      });
      W.clearTimeout(hintTimer);
      hintTimer = W.setTimeout(function () { v.classList.add('is-hinted'); }, 3500);
      D.addEventListener('keydown', onKey, true);
      focusEl(bClose);
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      unzoomAll();
      endGesture();
      v.classList.remove('is-open');
      D.documentElement.classList.remove('wh-pdp-lock');
      D.removeEventListener('keydown', onKey, true);
      W.clearTimeout(hintTimer);
      hideTimer = W.setTimeout(function () {
        v.hidden = true;
        resetDrag();
      }, reduced() ? 0 : 260);
      if (api.gallery) api.gallery.goToImage(index, true);
      var o = opener;
      opener = null;
      if (connected(o)) focusEl(o);
    }

    listen(track, 'scroll', onScroll, { passive: true }, api.bag);
    if (bClose) listen(bClose, 'click', close, false, api.bag);
    if (bZoom) listen(bZoom, 'click', function () { toggleZoom(); }, false, api.bag);
    if (bPrev) listen(bPrev, 'click', function () { goTo(index - 1); }, false, api.bag);
    if (bNext) listen(bNext, 'click', function () { goTo(index + 1); }, false, api.bag);

    /* Gestes : déplacement à la souris (zoomé), glisser vers le bas pour fermer,
       double toucher pour zoomer. Le balayage horizontal reste natif. */
    listen(track, 'pointerdown', function (e) {
      lastType = e.pointerType || 'mouse';
      if (!isOpen) return;
      if (e.isPrimary === false) {
        endGesture();
        return;
      }
      gesture = { id: e.pointerId, type: lastType, x: e.clientX, y: e.clientY, t: Date.now(), moved: false, axis: '', zoom: zoomed(), pan: null };
      if (gesture.zoom && lastType === 'mouse') {
        var pan = one('[data-wh-pdp-pan]', slides[index]);
        if (pan) {
          gesture.pan = pan;
          gesture.sl = pan.scrollLeft;
          gesture.st = pan.scrollTop;
          v.classList.add('is-panning');
          try { track.setPointerCapture(e.pointerId); } catch (x) { /* capture facultative */ }
          e.preventDefault();
        }
      }
    }, false, api.bag);

    listen(track, 'pointermove', function (e) {
      var g = gesture;
      if (!g || e.pointerId !== g.id) return;
      var dx = e.clientX - g.x;
      var dy = e.clientY - g.y;
      if (!g.moved && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) g.moved = true;
      if (g.pan) {
        g.pan.scrollLeft = g.sl - dx;
        g.pan.scrollTop = g.st - dy;
        return;
      }
      if (g.zoom || g.type === 'mouse') return;
      if (!g.axis && g.moved) g.axis = Math.abs(dy) > Math.abs(dx) * 1.2 ? 'y' : 'x';
      if (g.axis === 'y') {
        var drag = Math.max(0, dy);
        v.classList.add('is-dragging');
        track.style.transform = 'translate3d(0,' + Math.round(drag) + 'px,0)';
        v.style.opacity = String(clamp(1 - drag / 600, 0.45, 1));
      }
    }, false, api.bag);

    listen(track, 'pointerup', function (e) {
      var g = gesture;
      if (!g || e.pointerId !== g.id) return;
      gesture = null;
      v.classList.remove('is-panning');
      if (g.pan) {
        suppressClick = g.moved;
        return;
      }
      if (g.axis === 'y') {
        v.classList.remove('is-dragging');
        if (e.clientY - g.y > 110) {
          /* fondu de sortie depuis l'opacité atteinte pendant le geste */
          v.style.opacity = '';
          close();
        } else {
          resetDrag();
        }
        return;
      }
      if (g.type !== 'mouse' && !g.moved && Date.now() - g.t < 350) {
        var now = Date.now();
        if (now - lastTap < 320 && Math.abs(e.clientX - lastTapX) < 32 && Math.abs(e.clientY - lastTapY) < 32) {
          lastTap = 0;
          toggleZoom(e.clientX, e.clientY);
        } else {
          lastTap = now;
          lastTapX = e.clientX;
          lastTapY = e.clientY;
        }
      }
    }, false, api.bag);

    listen(track, 'pointercancel', endGesture, false, api.bag);

    /* Souris : clic sur la photo = zoom ; clic à côté (non zoomé) = fermer */
    listen(track, 'click', function (e) {
      if (suppressClick) {
        suppressClick = false;
        return;
      }
      if (lastType !== 'mouse' || !isOpen) return;
      var img = e.target && e.target.closest ? e.target.closest('img') : null;
      if (!img) {
        if (!zoomed()) close();
        return;
      }
      toggleZoom(e.clientX, e.clientY);
    }, false, api.bag);

    listen(W, 'resize', debounce(function () {
      if (!isOpen) return;
      unzoomAll();
      track.scrollLeft = index * width();
    }, 120), false, api.bag);

    api.viewer = {
      open: open,
      close: close,
      isOpen: function () { return isOpen; }
    };
    api.bag.push(function () {
      if (isOpen) close();
      W.clearTimeout(hideTimer);
      v.hidden = true;
    });
  }

  /* ---------- Accordéons (composant propre à la section) ---------- */
  function setAccordion(item, open) {
    item.classList.toggle('is-open', open);
    var b = one('[data-wh-pdp-acc-btn]', item);
    if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function initAccordions(api) {
    all('[data-wh-pdp-acc]', api.root).forEach(function (item) {
      var b = one('[data-wh-pdp-acc-btn]', item);
      if (!b) return;
      listen(b, 'click', function () {
        var open = !item.classList.contains('is-open');
        setAccordion(item, open);
        if (open && api.desc && item.contains(api.desc.el)) api.desc.measure();
      }, false, api.bag);
    });
  }

  function onBlockSelect(e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    var item = t.closest('[data-wh-pdp-acc]');
    if (item && t.closest(ROOT)) setAccordion(item, true);
  }

  /* ---------- Description longue : « Lire la suite » sur mobile ---------- */
  function initDescription(api) {
    var d = one('[data-wh-pdp-desc]', api.root);
    if (!d || d.getAttribute('data-clamp') !== 'true') return;
    var body = one('[data-wh-pdp-desc-body]', d);
    var more = one('[data-wh-pdp-more]', d);
    if (!body || !more) return;
    var lastWidth = W.innerWidth;

    function measure() {
      if (!isMobile()) {
        d.classList.remove('is-clamped');
        more.hidden = true;
        return;
      }
      if (d.classList.contains('is-expanded')) {
        more.hidden = false;
        return;
      }
      d.classList.remove('is-clamped');
      var lh = parseFloat(W.getComputedStyle(body).lineHeight) || 25;
      if (body.scrollHeight > lh * 9) {
        d.classList.add('is-clamped');
        more.hidden = false;
      } else {
        more.hidden = true;
      }
    }

    listen(more, 'click', function () {
      var expand = !d.classList.contains('is-expanded');
      d.classList.toggle('is-expanded', expand);
      more.setAttribute('aria-expanded', expand ? 'true' : 'false');
      more.textContent = expand ? 'Show less' : 'Read more';
      if (!expand) {
        var r = d.getBoundingClientRect();
        var top = headerBottom() + 16;
        if (r.top < top) {
          var y = (W.pageYOffset || D.documentElement.scrollTop) + r.top - top - 64;
          try { W.scrollTo({ top: Math.max(0, y), behavior: reduced() ? 'auto' : 'smooth' }); } catch (x) { W.scrollTo(0, Math.max(0, y)); }
        }
      }
    }, false, api.bag);

    listen(W, 'resize', debounce(function () {
      if (W.innerWidth === lastWidth) return;
      lastWidth = W.innerWidth;
      measure();
    }, 150), false, api.bag);

    api.desc = { el: d, measure: measure };
    measure();
    if (D.fonts && D.fonts.ready && typeof D.fonts.ready.then === 'function') {
      D.fonts.ready.then(function () { if (connected(d)) measure(); });
    }
  }

  /* ---------- Colonne d'achat collante (tablette, ordinateur) ---------- */
  function initBuyColumn(api) {
    var buy = one('[data-wh-pdp-buy]', api.root);
    if (!buy) return;
    var raf = 0;

    function update() {
      raf = 0;
      var root = api.root;
      if (!(mqColumns && mqColumns.matches)) {
        root.style.removeProperty('--wh-pdp-sticky-top');
        return;
      }
      var vh = W.innerHeight || D.documentElement.clientHeight;
      var h = buy.offsetHeight;
      if (h + headerBottom() + 48 <= vh) {
        root.style.removeProperty('--wh-pdp-sticky-top');
        return;
      }
      /* Plus haute que l'écran : elle défile puis se cale par le bas */
      root.style.setProperty('--wh-pdp-sticky-top', Math.round(vh - h - 24) + 'px');
    }

    function schedule() {
      if (!raf) raf = frame(update);
    }

    if (W.ResizeObserver) {
      var ro = new W.ResizeObserver(schedule);
      ro.observe(buy);
      api.observers.push(ro);
    }
    listen(W, 'resize', schedule, false, api.bag);
    update();
  }

  /* ---------- Livraison offerte : vrai panier ---------- */
  function refreshCart(api) {
    if (typeof W.fetch !== 'function') return;
    var url = ((W.WiseRoutes && W.WiseRoutes.cart) || '/cart') + '.js';
    W.fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !connected(api.root)) return;
        api.cart = {
          total: Number(cart.total_price) || 0,
          ids: (cart.items || []).map(function (item) { return Number(item.variant_id); })
        };
        syncShip(api);
      })
      .catch(function () { /* hors ligne : on garde le dernier état */ });
  }

  function initShipping(api) {
    var box = one('[data-wh-pdp-ship]', api.root);
    if (!box) return;
    api.ship = {
      box: box,
      msg: one('[data-wh-pdp-ship-msg]', box),
      bar: one('[data-wh-pdp-ship-bar]', box)
    };
    api.cart = {
      total: Number(api.cfg.cartTotal) || 0,
      ids: (api.cfg.cartIds || []).map(Number)
    };
    var refresh = debounce(function () { refreshCart(api); }, 300);
    /* wise.js réécrit [data-cart-count] après chaque ajout ou modification du panier */
    var count = D.querySelector('[data-cart-count]');
    if (count && W.MutationObserver) {
      var mo = new W.MutationObserver(refresh);
      mo.observe(count, { childList: true, characterData: true, subtree: true });
      api.observers.push(mo);
    }
    listen(W, 'pageshow', function (e) { if (e.persisted) refresh(); }, false, api.bag);
    /* Le rendu serveur part du panier réel ; on le relit une fois au repos (/cart.js)
       pour rester juste même si la page vient d'un cache. */
    var idle = W.requestIdleCallback
      ? function (fn) { return W.requestIdleCallback(fn, { timeout: 2500 }); }
      : function (fn) { return W.setTimeout(fn, 900); };
    var cancelIdle = W.cancelIdleCallback ? W.cancelIdleCallback.bind(W) : W.clearTimeout.bind(W);
    var idleId = idle(function () { refreshCart(api); });
    api.bag.push(function () { cancelIdle(idleId); });
  }

  /* ---------- Guide des tailles : focus et état des onglets ---------- */
  function initGuide(api) {
    var modal = one('#size-guide', api.root);
    if (!modal) return;
    var box = one('[data-wh-pdp-guide-box]', modal);
    var tabs = all('[data-guide-tab]', modal);
    var wasOn = modal.classList.contains('is-on');

    function syncTabs() {
      tabs.forEach(function (t) {
        var pressed = t.classList.contains('is-active') ? 'true' : 'false';
        if (t.getAttribute('aria-pressed') !== pressed) t.setAttribute('aria-pressed', pressed);
      });
    }

    if (W.MutationObserver) {
      var mo = new W.MutationObserver(function () {
        syncTabs();
        var on = modal.classList.contains('is-on');
        if (on === wasOn) return;
        wasOn = on;
        if (on) {
          /* Écran tactile : pas de clavier qui surgit à l'ouverture */
          if (!finePointer() && box) {
            var a = D.activeElement;
            if (a && a.tagName === 'INPUT' && modal.contains(a)) a.blur();
            focusEl(box);
          }
        } else {
          var o = api.guideOpener;
          api.guideOpener = null;
          if (connected(o)) focusEl(o);
        }
      });
      mo.observe(modal, { attributes: true, attributeFilter: ['class'] });
      tabs.forEach(function (t) { mo.observe(t, { attributes: true, attributeFilter: ['class'] }); });
      api.observers.push(mo);
    }
    syncTabs();

    /* Le focus reste dans le guide tant qu'il est ouvert */
    listen(modal, 'keydown', function (e) {
      if (e.key !== 'Tab' || !modal.classList.contains('is-on')) return;
      var f = all('button, input, a[href]', modal).filter(function (el) {
        return !el.disabled && el.offsetParent !== null;
      });
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && (D.activeElement === first || D.activeElement === box)) {
        e.preventDefault();
        focusEl(last);
      } else if (!e.shiftKey && D.activeElement === last) {
        e.preventDefault();
        focusEl(first);
      }
    }, false, api.bag);
  }

  /* ---------- Favori : état annoncé ---------- */
  function initWish(api) {
    var w = one('[data-wish]', api.root);
    if (!w) return;
    function update() {
      var on = w.classList.contains('is-active');
      var pressed = on ? 'true' : 'false';
      var label = on ? 'Remove from wishlist' : 'Add to wishlist';
      if (w.getAttribute('aria-pressed') !== pressed) w.setAttribute('aria-pressed', pressed);
      if (w.getAttribute('aria-label') !== label) w.setAttribute('aria-label', label);
    }
    if (W.MutationObserver) {
      var mo = new W.MutationObserver(update);
      mo.observe(w, { attributes: true, attributeFilter: ['class'] });
      api.observers.push(mo);
    }
    update();
  }

  /* ---------- Retour en stock : confirmation de CE formulaire seulement ---------- */
  function initRestock(api) {
    var box = one('[data-wh-pdp-restock]', api.root);
    if (!box) return;
    api.restock = box;
    var ok = one('[data-wh-pdp-restock-ok]', box);
    var fields = one('[data-wh-pdp-restock-fields]', box);
    var err = one('[data-wh-pdp-restock-err]', box);
    /* Shopify marque tous les formulaires « customer » de la page (lettre du pied de page
       comprise) : seule une ancre #wh-pdp-restock… (return_to, ou id du formulaire
       #wh-pdp-restock-form) désigne ce formulaire. Sans ancre du tout, on accepte
       ?customer_posted=true (Shopify a pu perdre le hash). Le paramètre peut aussi
       atterrir après le # : Liquid ne le voit pas, la confirmation est alors créée ici. */
    var hash = String(W.location.hash || '');
    var posted = /[?&]customer_posted=true/.test(String(W.location.search || '') + hash);
    var mine = hash.indexOf('#wh-pdp-restock') === 0 || (posted && (hash === '' || hash === '#'));
    if (mine && posted && !ok && !err) {
      var form = one('form', box);
      if (form) {
        ok = D.createElement('p');
        ok.className = 'wh-pdp__restock-ok';
        ok.setAttribute('role', 'status');
        ok.setAttribute('data-wh-pdp-restock-ok', '');
        var okText = D.createElement('span');
        okText.textContent = 'Thank you. We will email you when this item is back.';
        ok.appendChild(okText);
        form.insertBefore(ok, form.firstChild);
      }
    }
    if (ok) {
      if (mine) {
        box.__whForce = true;
        ok.hidden = false;
        if (fields) fields.hidden = true;
      } else {
        ok.hidden = true;
        if (fields) fields.hidden = false;
      }
    }
    if (err) {
      if (mine) box.__whForce = true;
      else err.hidden = true;
    }
    if (box.__whForce) {
      box.hidden = false;
      frame(function () {
        try { box.scrollIntoView({ block: 'center' }); } catch (x) { box.scrollIntoView(); }
      });
    }
  }

  /* ---------- Cycle de vie ---------- */
  function init(root) {
    if (!root || root.nodeType !== 1 || root.__whPdp) return;
    var api = {
      root: root,
      bag: [],
      observers: [],
      cfg: readJSON(one('[data-wh-pdp-config]', root)) || {},
      variants: readJSON(one('[data-variants-json]', root)) || [],
      form: one('#pdp-form', root) || one('form[action*="/cart/add"]', root),
      opts: all('.opt', root),
      atc: one('[data-wh-pdp-atc]', root),
      stickyBtn: one('[data-sticky-atc]', root),
      wa: one('[data-wh-pdp-wa]', root),
      state: null
    };
    root.__whPdp = api;
    root.classList.add('is-ready');
    safe(function () { initGallery(api); });
    safe(function () { initViewer(api); });
    safe(function () { initAccordions(api); });
    safe(function () { initDescription(api); });
    safe(function () { initBuyColumn(api); });
    safe(function () { initShipping(api); });
    safe(function () { initRestock(api); });
    safe(function () { initGuide(api); });
    safe(function () { initWish(api); });
    safe(function () { initVariants(api); });
    safe(function () { sync(api); });
  }

  function destroy(root) {
    var api = root && root.__whPdp;
    if (!api) return;
    api.bag.forEach(function (fn) { safe(fn); });
    api.observers.forEach(function (o) { safe(function () { o.disconnect(); }); });
    api.bag = [];
    api.observers = [];
    W.clearTimeout(api.invalidTimer);
    D.documentElement.classList.remove('wh-pdp-lock');
    root.classList.remove('is-ready');
    root.__whPdp = null;
  }

  function scopeRoots(scope) {
    var base = scope && scope.nodeType === 1 ? scope : D;
    var list = all(ROOT, base);
    if (base !== D && typeof base.matches === 'function' && base.matches(ROOT)) list.unshift(base);
    return list;
  }

  function boot(scope) {
    scopeRoots(scope).forEach(function (root) {
      safe(function () { init(root); });
    });
  }

  function teardown(section) {
    if (!section || section.nodeType !== 1) return;
    scopeRoots(section).forEach(destroy);
  }

  D.addEventListener('submit', onSubmitCapture, true);
  D.addEventListener('shopify:block:select', onBlockSelect);

  if (W.WH && typeof W.WH.ready === 'function') {
    W.WH.ready(boot);
    if (typeof W.WH.unload === 'function') W.WH.unload(teardown);
  } else {
    if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { boot(D); });
    else boot(D);
    D.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    D.addEventListener('shopify:section:unload', function (e) { teardown(e.target); });
  }
})();
